import React from 'react'
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import datecalender from "../../../../assets/images/datecalender.svg";
import planpricingtooltip from "../../../../assets/images/planpricingtooltips.svg";
import articledashboard from "../../../../assets/images/articledashboard.svg";

import DatePicker3 from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { formatInputValue } from '../../../../shared/helper';
import { TagsInput } from "react-tag-input-component";
import { NEW_URL } from '../../../../constants/applicationConstants';
import { MyAdCard } from '../../../common/myAdCard/myAdCard';
import adsbg from '../../../../assets/Instituteppvimages/ads_bg.svg';
import cross from '../../../../assets/images/cross.svg';
import externallinkicon from '../../../../assets/images/external_link.svg';
import uploadfile from '../../../../assets/Instituteppvimages/uploadfile.svg';
import { Trans, useTranslation } from "react-i18next";
import close_btn from '../../../../assets/images/white_cross.svg';
import './myAds.model.css';
import { Pagination } from '../../../common/pagination/uiPagination';

const MyAdsJsx = (props) => {
    const {
        blogFormData,
        formError,
        onDateChange,
        onInputChangeHandler,
        onRadioButtonClick,
        isExpires,
        showAddModal,
        onModalClose,
        onSubmitButtonclick,
        onTouchHandler,
        formSubmitButtonDisable,
        categoryData,
        subCategoryData,
        onMetaTagChange,
        onEditButtonClick,
        onDeleteButtonClick,
        adData,
        onScrollerChange,
        profileImagePreviewUrl,
        imgURL,
        editMode,
        onFileChange, page, onPaginationButtonClick, hitSearch, searchProductByKeyword
    } = props;

    const itemsPerPage = 10

    const [currentPage] = useState(1);
    const currentItems = adData?.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    const limitData = JSON.parse(localStorage.getItem('loginData'));

    let flowName = localStorage.getItem('flowName');

    const { t } = useTranslation();
    const [activeModal, setActiveModal] = useState(null);

    const openModal = (modalName) => setActiveModal(modalName);
    const closeModal = () => setActiveModal(null);
    return (
        <>

            <div className="ad-main">

                {flowName === 'expert' && <div>
                    <div className="dashboardrightpannerinnerleft">
                        <h2 className="d-none d-sm-block">{t("instituteAds.TITLE")}</h2>
                        <h2 className="h2_style font-weight-600 d-block d-lg-none d-sm-none d-md-none"><span className="headingicon d-block d-lg-none d-sm-none d-md-none "><img alt="article" src={articledashboard} /></span>Ads</h2>
                        <h5><Trans i18nKey={`instituteAds.ADDISCRIPTION`}></Trans></h5>
                    </div>
                </div>}

                {!editMode &&
                    <div className="craete-ad-containt">

                        <div className="craete-ad-containt-left">
                            <p className="subtitle"> {t("instituteAds.SUBTITLE")} </p>
                            <p className="subtitle">{t("instituteAds.CREATEDADS")}</p>
                            <>
                                <Button className="mainuser d-block d-lg-none d-sm-none d-md-none " onClick={() => openModal("modal1")}>  <img className="guide-img" src={planpricingtooltip} alt={' '} /> <span className="guide-text">Help Guide</span></Button>


                                {/* Modal 1 */}
                                <div >
                                    <Modal className="psmodalps" show={activeModal === "modal1"} onHide={closeModal}>
                                        <Modal.Header closeButton>

                                        </Modal.Header>
                                        <Modal.Body>
                                            <Button className="csbtn" onClick={() => openModal("modal2")}><li><span className="dropdown-item" type="button">1. {t("instituteAds.HOWTOCREATE")}</span></li></Button>
                                            <Button className="csbtn" onClick={() => openModal("modal3")}><li><span className="dropdown-item" type="button">2. {t("instituteAds.EDITAD")}</span></li></Button>
                                            <Button className="csbtn" onClick={() => openModal("modal4")}><li><span className="dropdown-item" type="button">3. {t("instituteAds.DELETEEXISTINGAD")}</span></li></Button>
                                            <Button className="csbtn" onClick={() => openModal("modal5")}><li><span className="dropdown-item" type="button">4. {t("instituteAds.ADDMOEAD")} </span></li></Button>
                                            <Button className="csbtn" onClick={() => openModal("modal6")}><li><span className="dropdown-item" type="button">5. {t("instituteAds.ADSTATUS")}</span></li></Button>
                                        </Modal.Body>
                                    </Modal>

                                    {/* Modal 2 */}
                                    <Modal show={activeModal === "modal2"} onHide={closeModal}>
                                        <Modal.Header closeButton>
                                            <Button className="leftlink" variant="link" onClick={() => openModal("modal1")}>

                                            </Button>
                                        </Modal.Header>
                                        <Modal.Body>

                                            <ul className="dropdownlist">
                                                <li><span className="dropdown-item" type="button">{t("instituteAds.UPLOADADIMAGE")}</span></li>
                                                <li><span className="dropdown-item" type="button">{t("instituteAds.ENTERADCAPTION")}</span></li>
                                                <li><span className="dropdown-item" type="button">{t("instituteAds.EXPIREDATE")}
                                                    <ol>
                                                        <li>{t("instituteAds.SELECTEXPIRE")}</li>
                                                        <li>{t("instituteAds.ENTERVALIDDATE")}</li>
                                                    </ol></span></li>
                                                <li><span className="dropdown-item" type="button">{t("instituteAds.NEVEREXPIRE")}</span></li>
                                                <li><span className="dropdown-item" type="button">{t("instituteAds.CLICKSUBMIT")}</span></li>
                                                <li><span className="dropdown-item" type="button">{t("instituteAds.DELETEIT")}</span></li>

                                            </ul>
                                        </Modal.Body>
                                    </Modal>
                                    {/* Modal 3 */}
                                    <Modal show={activeModal === "modal3"} onHide={closeModal}>
                                        <Modal.Header closeButton>
                                            <Button className="leftlink" variant="link" onClick={() => openModal("modal1")}>

                                            </Button>
                                        </Modal.Header>
                                        <Modal.Body>

                                            <ul className="dropdownlist">

                                                <li><span className="dropdown-item"  >{t("instituteAds.CLICKEDIT")}</span></li>

                                                <li><span className="dropdown-item"  >{t("instituteAds.POPUPINFO")}
                                                    <ol>
                                                        <li>{t("instituteAds.UPLOADNEWAD")} </li>
                                                        <li>{t("instituteAds.EDITADCAPTION")} </li>
                                                    </ol> </span></li>
                                                <li><span className="dropdown-item"  >{t("instituteAds.CLICKSUBMITBUTTON")} </span></li>
                                                <li><span className="dropdown-item"  >{t("instituteAds.DISCARDCHANGES")} </span></li>

                                            </ul>
                                        </Modal.Body>
                                    </Modal>
                                     {/* Modal 4 */}
                                     <Modal show={activeModal === "modal4"} onHide={closeModal}>
                                        <Modal.Header closeButton>
                                            <Button className="leftlink" variant="link" onClick={() => openModal("modal1")}>

                                            </Button>
                                        </Modal.Header>
                                        <Modal.Body>

                                        <ul className="dropdownlist">
                                           
                                            <li><span className="dropdown-item"  >{t("instituteAds.DELETEOPTION")} </span></li>


                                        </ul>
                                        </Modal.Body>
                                    </Modal>
                                      {/* Modal 5 */}
                                      <Modal show={activeModal === "modal5"} onHide={closeModal}>
                                        <Modal.Header closeButton>
                                            <Button className="leftlink" variant="link" onClick={() => openModal("modal1")}>

                                            </Button>
                                        </Modal.Header>
                                        <Modal.Body>
                                        <ul className="dropdownlist">
                                          
                                            <li><span className="dropdown-item"  >{t("instituteAds.ADLIMIT")}</span></li>

                                        </ul>
                                        </Modal.Body>
                                    </Modal>
                                     {/* Modal 6 */}
                                     <Modal show={activeModal === "modal6"} onHide={closeModal}>
                                        <Modal.Header closeButton>
                                            <Button className="leftlink" variant="link" onClick={() => openModal("modal1")}>

                                            </Button>
                                        </Modal.Header>
                                        <Modal.Body>
                                        <ul className="dropdownlist">
                                         
                                            <li><span className="dropdown-item"  >{t("instituteAds.SWITCH")} </span></li>
                                            <li><span className="dropdown-item"  >{t("instituteAds.ACTIVETOGGLE")}</span></li>
                                            <li><span className="dropdown-item"  >{t("instituteAds.INACTIVETOGGLE")} </span></li>
                                        </ul>
                                        </Modal.Body>
                                    </Modal>
                                </div>
                            </>

                            <div className="userguide d-none d-sm-block">
                                <div className="dropdown-toggle userdropdown-toggle" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img className="guide-img" src={planpricingtooltip} alt={' '} /> <span className="guide-text">Help Guide</span> </div>

                                <ul className="dropdown-menu userdropdown-menu" aria-labelledby="dropdownMenu2">
                                    <div className="closebutton"><img src={close_btn} alt="close-btn" /></div>
                                    <li><span className="dropdown-item" type="button">{t("instituteAds.HOWTOCREATE")}</span>
                                        <ul className="dropdown-menu dropdown-submenu">
                                            <div className="closebutton"><img src={close_btn} alt="close-btn" /></div>
                                            <li><span className="dropdown-item" type="button">{t("instituteAds.UPLOADADIMAGE")}</span></li>
                                            <li><span className="dropdown-item" type="button">{t("instituteAds.ENTERADCAPTION")}</span></li>
                                            <li><span className="dropdown-item" type="button">{t("instituteAds.EXPIREDATE")}
                                                <ol>
                                                    <li>{t("instituteAds.SELECTEXPIRE")}</li>
                                                    <li>{t("instituteAds.ENTERVALIDDATE")}</li>
                                                </ol></span></li>
                                            <li><span className="dropdown-item" type="button">{t("instituteAds.NEVEREXPIRE")}</span></li>
                                            <li><span className="dropdown-item" type="button">{t("instituteAds.CLICKSUBMIT")}</span></li>
                                            <li><span className="dropdown-item" type="button">{t("instituteAds.DELETEIT")}</span></li>

                                        </ul>
                                    </li>
                                    <li><span className="dropdown-item" type="button">{t("instituteAds.EDITAD")}</span>
                                        <ul className="dropdown-menu dropdown-submenu">
                                            <div className="closebutton"><img src={close_btn} alt="close-btn" /></div>
                                            <li><span className="dropdown-item"  >{t("instituteAds.CLICKEDIT")}</span></li>

                                            <li><span className="dropdown-item"  >{t("instituteAds.POPUPINFO")}
                                                <ol>
                                                    <li>{t("instituteAds.UPLOADNEWAD")} </li>
                                                    <li>{t("instituteAds.EDITADCAPTION")} </li>
                                                </ol> </span></li>
                                            <li><span className="dropdown-item"  >{t("instituteAds.CLICKSUBMITBUTTON")} </span></li>
                                            <li><span className="dropdown-item"  >{t("instituteAds.DISCARDCHANGES")} </span></li>

                                        </ul>
                                    </li>
                                    <li><span className="dropdown-item" type="button">{t("instituteAds.DELETEEXISTINGAD")}</span>
                                        <ul className="dropdown-menu dropdown-submenu">
                                            <div className="closebutton"><img src={close_btn} alt="close-btn" /></div>
                                            <li><span className="dropdown-item"  >{t("instituteAds.DELETEOPTION")} </span></li>


                                        </ul>
                                    </li>
                                    <li><span className="dropdown-item" type="button">{t("instituteAds.ADDMOEAD")} </span>
                                        <ul className="dropdown-menu dropdown-submenu">
                                            <div className="closebutton"><img src={close_btn} alt="close-btn" /></div>
                                            <li><span className="dropdown-item"  >{t("instituteAds.ADLIMIT")}</span></li>

                                        </ul>
                                    </li>
                                    <li><span className="dropdown-item" type="button">{t("instituteAds.ADSTATUS")}</span>
                                        <ul className="dropdown-menu dropdown-submenu">
                                            <div className="closebutton"><img src={close_btn} alt="close-btn" /></div>
                                            <li><span className="dropdown-item"  >{t("instituteAds.SWITCH")} </span></li>
                                            <li><span className="dropdown-item"  >{t("instituteAds.ACTIVETOGGLE")}</span></li>
                                            <li><span className="dropdown-item"  >{t("instituteAds.INACTIVETOGGLE")} </span></li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <button type="button" disabled={adData?.length === limitData?.totalAdsLimit} className="col-4 craete-ads-button" onClick={() => onModalClose(true)}>{t("MYADS.CREATEAD")}</button>
                    </div>
                }
                {showAddModal && <div className="opmodal" style={{ marginTop: '30px' }}>

                    <div className="craete-ads">
                        <div>
                            <button type="button" className="close-ads" onClick={() => onModalClose(false)}><img src={cross} alt="cross" /></button>
                        </div>

                        <div className="row input-form-div">
                            <div className="col-lg-12"> <p className="ads-title">{editMode ? t("MYADS.EDITADD") : "Create New Ad"}</p></div>
                            <div className="col-lg-12"> <div className="samll">{editMode ? t("MYADS.EDITADDTAG") : "How to Create an Ad?"}</div></div>

                            <div className="col-lg-6 col-sm-6">
                                <div className="adsbg">
                                    <img className="adsimg" src={adsbg} alt={'icon'} />
                                    <div className="outerlogo">
                                    </div>
                                    <div className="uploadexpert mb-4">
                                        <div className="d-flex border-divnew">
                                            <div className="upload-image"> <img src={uploadfile} alt={'icon'} /></div>
                                            <div className="brows-part">
                                                {!(editMode || profileImagePreviewUrl) ? <><p className="uplod-title"><b>{t("instituteAds.UPLOADLOGO")}</b><br /><span className="uplogo">{t("instituteAds.UPLOADLOGODIMENTION")}</span> <span className="divider-text">Or</span></p>

                                                </>
                                                    :
                                                    <div className="uploadlogo chnageupload">
                                                        <div className="brows-partchange">
                                                            <input type="file" id="upload_file" name="" onChange={onFileChange} />
                                                            <label for="upload_file">{"Change Image"}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    profileImagePreviewUrl ? <img
                                                        src={profileImagePreviewUrl}
                                                        className="select-img"
                                                        alt="edit profile"
                                                    /> : <div className="uploadlogo">
                                                        <input type="file" id="upload_filelogo" name="" onChange={onFileChange} />
                                                        <label for="upload_filelogo">

                                                            {editMode ?
                                                                <img
                                                                    src={`${NEW_URL}/${imgURL}`}
                                                                    className="select-img"
                                                                    alt="edit profile"
                                                                />
                                                                : <p>Browse</p>
                                                            }

                                                        </label>
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="input-container form-group radioform">
                                    <label className="radiocontrol">
                                        {t("instituteAds.EXPIRES")}<input type="radio" name="radio" onClick={() => onRadioButtonClick(true)} checked={blogFormData.isExpires} /></label>

                                    <label className="radiocontrol">
                                        {t("instituteAds.NEVEREXPIRES")}<input type="radio" name="radio" onClick={() => onRadioButtonClick(false)} checked={!blogFormData.isExpires} /></label>
                                </div>
                                {isExpires && <div className="row craete-ads-date">
                                    <div className="col-lg-6">
                                        <DatePicker3 className="input-caption" name="startDate"
                                            onChange={(date) => { onDateChange('validFrom', date) }}
                                            inputPlaceholder="dd/mm/yyyy"
                                            shouldHighlightWeekends
                                            wrapperClassName="input-caption"
                                            maximumDate={{
                                                year: new Date().getFullYear(),
                                                month: new Date().getMonth() + 1,
                                                day: new Date().getDate()
                                            }}
                                            renderInput={({ ref }) => (
                                                <><label className="placeholder">Valid From*</label>
                                                    <input
                                                        ref={ref}
                                                        placeholder=""
                                                        type="text"
                                                        required
                                                        className="input-caption-border"
                                                        value={formatInputValue(blogFormData?.validFrom)}
                                                    />


                                                    <span className="input-icon-add"><img src={datecalender} alt={'icon'} /></span>
                                                </>
                                            )}
                                            formatInputText={() => formatInputValue(blogFormData?.validFrom)}

                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <DatePicker3 className="input-caption" name="startDate"
                                            onChange={(date) => { onDateChange('validTill', date) }}
                                            inputPlaceholder="dd/mm/yyyy"
                                            shouldHighlightWeekends
                                            wrapperClassName="input-caption"
                                            minimumDate={{
                                                year: new Date().getFullYear(),
                                                month: new Date().getMonth() + 1,
                                                day: new Date().getDate() + 1
                                            }}
                                            renderInput={({ ref }) => (
                                                <><label className="placeholder">Valid Till*</label>
                                                    <input
                                                        ref={ref}
                                                        placeholder=""
                                                        type="text"
                                                        required
                                                        className="input-caption-border"
                                                        value={formatInputValue(blogFormData?.validTill)}
                                                    />

                                                    <span className="input-icon-add"><img src={datecalender} alt={'icon'} /></span>
                                                </>
                                            )}
                                            formatInputText={() => formatInputValue(blogFormData?.validTill)}
                                        />
                                    </div>
                                </div>
                                }
                            </div>
                            <div className="col-lg-6 col-sm-6">
                                <div className="textarea-caption">
                                    <label className="placeholder mt-0">Caption*</label>
                                    <textarea
                                        onBlur={onTouchHandler}
                                        className={"textarea-caption"}
                                        placeholder=" "
                                        value={blogFormData.caption}
                                        name="caption"
                                        onChange={onInputChangeHandler}
                                        maxLength={500}></textarea>
                                    <span className="text-danger">
                                        {formError['caption'] &&
                                            (formError['caption'] === "req"
                                                ? 'Caption is required'
                                                : '')}
                                    </span>
                                </div>

                                <div className="mt-2 mb-2 input-container form-group ps-6">
                                    <label className="placeholder">{t("instituteAds.CATEGORY")}</label>
                                    <select className="input form-control form-select" onChange={onInputChangeHandler} name="category">
                                        <option value="">{t("instituteAds.SELECTCATEGORY")}</option>
                                        {categoryData?.map((item) => {
                                            return (
                                                <>
                                                    <option value={item.institutionCategoryId} selected={item.institutionCategoryId === blogFormData.category}>{item.name}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="mb-2 input-container form-group ps-6">
                                    <label className="placeholder">{t("instituteAds.SUBCAT")}</label>
                                    <select className="input form-control form-select" onChange={onInputChangeHandler} name="subCategory">
                                        <option value="">{t("instituteAds.SELECTSUBCAT")}</option>
                                        {subCategoryData?.map((item, i) => {
                                            return (
                                                <>
                                                    <option value={item.institutionCategoryId} selected={item.institutionCategoryId === blogFormData.subCategory}>{item.name}</option>
                                                </>
                                            )
                                        })}
                                    </select>

                                </div>
                            </div>

                            <div className="col-lg-12 ">
                            <div className="input-caption">
                                    <label className="placeholder">{t("instituteAds.METATAG")}<span className="plantooltip custooltip" ><img src={planpricingtooltip} alt={'icon'} className="tooltipim" />
                                        <div className="tooltipcontent">{t("instituteAds.METATAGTOOLTIP")}</div>
                                    </span></label>
                                    <div className="input-caption-border" id="tagInput" titleLbl={'Product Meta Tag'}
                                        onFocus={() => {
                                            let elem = document.getElementById("tagInput");
                                            elem.classList.add("my-classfocus");
                                        }}
                                        onBlur={() => {
                                            let elem = document.getElementById("tagInput");
                                            elem.classList.remove("my-classfocus");
                                        }}

                                    >

 <TagsInput
  value={blogFormData.metaTag}
  onKeyDown={(e) => {
    // if (e.key === 'Enter' || e.keyCode === 13) {
    //   e.preventDefault();
    //   if (e.target.value) {
    //     onMetaTagChange([...blogFormData.metaTag, e.target.value]);
    //     e.target.value = "";
    //   }
    // }
  }}
  onBlur={(e) => {
    if (e.target.value) {
      onMetaTagChange([...blogFormData.metaTag, e.target.value]);
      e.target.value = "";
    }
  }}
//   inputProps={{ 
//     enterKeyHint: "done",   // <--- this helps Android keyboard
//     inputMode: "text" 
//   }}
onChange={(e) => onMetaTagChange(e, blogFormData.metaTag)}
  label=" "
  name="metaTags"
  placeHolder=" "
  classname={{ tag: 'tag-cls', input: 'pt' }}
/>

                                    </div>


                                </div>
                                {/* <div className="input-caption d-none d-sm-block">
                                    <label className="placeholder">{t("instituteAds.METATAG")}<span className="plantooltip custooltip" ><img src={planpricingtooltip} alt={'icon'} className="tooltipim" />
                                        <div className="tooltipcontent">{t("instituteAds.METATAGTOOLTIP")}</div>
                                    </span></label>
                                    <div className="input-caption-border" id="tagInput" titleLbl={'Product Meta Tag'}
                                        onFocus={() => {
                                            let elem = document.getElementById("tagInput");
                                            elem.classList.add("my-classfocus");
                                        }}
                                        onBlur={() => {
                                            let elem = document.getElementById("tagInput");
                                            elem.classList.remove("my-classfocus");
                                        }}

                                    >

                                        <TagsInput
                                            value={blogFormData.metaTag}
                                            onChange={onMetaTagChange}
                                            label=""
                                            name="metaTags"
                                            placeHolder=" "
                                            classname={{ tag: 'tag-cls', input: 'input-caption' }}
                                        />
                                      


                                    </div>


                                </div> */}
                                <div className="input-caption mb-4">
                                    <label className="placeholder">{t("instituteAds.EXTERNALLINK")}*</label>
                                    <input
                                        onBlur={onTouchHandler}
                                        className={'input form-control externallink'}
                                        placeholder=" "
                                        value={blogFormData.link}
                                        name="link"
                                        onChange={onInputChangeHandler}
                                        maxLength={500}
                                    />
                                    <span className="externallink"><img src={externallinkicon} alt={`icon`} /></span>
                                    <span className="text-danger">
                                        {formError['link'] &&
                                            (formError['link'] === "req"
                                                ? 'Link is Required'
                                                : 'Enter a valid link')}
                                    </span>
                                </div>
                                <div className="mb-4 input-container form-group d-flex justify-content-right flex-row-reverse">
                                    <button type="button" disabled={formSubmitButtonDisable} className="mainbutton" onClick={() => onSubmitButtonclick()}>{editMode ? t("instituteAds.SAVE") : t("instituteAds.SUBMIT")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
                {!showAddModal &&
                    <>
                        <div className="p-2" >
                            <p className="adstitle">{t("instituteAds.TITLE")}</p>
                            <p className="adsubtitle">{t("instituteAds.VIIBLEAD")} </p>
                            <p className="adsubtitle">{t("instituteAds.BELOWAD")}  {t("instituteAds.YOUCANUPLOAD")} {limitData?.totalAdsLimit} {t("instituteAds.BELOWAD1")}</p>
                        </div>

                        {adData?.length > 0 || (props.keyword !== '' && props.keyword) ? (
                            <>
                                <section className="offersearch">
                                    <div className="container">
                                        <div className="customsearchblock">
                                            <input
                                                type="search"
                                                value={props.keyword}
                                                placeholder=""
                                                onChange={searchProductByKeyword}
                                            />
                                            <button
                                                className="headersearch"
                                                disabled={!props?.keyword?.length}
                                                onClick={() => hitSearch()}
                                            >
                                                {t("COMMON.SEARCH")}
                                            </button>
                                        </div>
                                        <h2>{t("PRODUCTS.SEARCHLINEONE")}</h2>
                                        <h4>{t("PRODUCTS.SEARCHLINETWO")}</h4>
                                    </div>
                                </section>

                                {/* Render each item below the search box */}
                                {currentItems?.map((data, index) => (
                                    <div key={index}>
                                        {/* Render your product/ad component here using `data` */}
                                    </div>
                                ))}
                            </>

                        ) : (
                            <div className="dropdefault">
                                {/* No results / default content */}
                            </div>
                        )
                        }

                        <div className="adsblog customad">
                            <div className="row">
                                {
                                    adData?.length > 0 ?
                                        currentItems?.map(data => {
                                            return < MyAdCard
                                                data={data}
                                                onEditButtonClick={() => onEditButtonClick(data)}
                                                onDeleteButtonClick={() => onDeleteButtonClick(data)}
                                                onScrollerChange={() => onScrollerChange(data)}
                                            />
                                        }) :
                                        <div className="dropdefault text-center mb-5">

                                            <div className="dropdefaulttext">
                                                <h5>{t("instituteAds.LIVEAD")} </h5>
                                                <h5>{t("instituteAds.CREATENEWAD")}</h5>
                                            </div>

                                        </div>
                                }
                                {currentItems?.length > 0 && <section className="newpagination" > <Pagination
                                    currentPage={currentPage}
                                    page={page}
                                    itemsPerPage={itemsPerPage}
                                    allOffersData={adData}
                                    currentItems={currentItems}
                                    onPaginationButtonClick={onPaginationButtonClick}

                                /></section>}
                            </div>
                        </div>
                    </>
                }

            </div>

        </>
    );
};

export default MyAdsJsx;
